import { LinkIcon } from '@chain-zen/ui'
import React from 'react'

import { ExternalTrackingLinkProviderEnum } from '../../types/tracking'
import { ATTFleetManagementIcon } from './provider-icons/att-fleet-management-icon'
import { GeotabIcon } from './provider-icons/geotab-icon'
import { SamsaraIcon } from './provider-icons/samsara-icon'
import { TruckerToolsIcon } from './provider-icons/trucker-tools-icon'

interface IProviderIcon {
  provider: string | null
  size?: number
}

type ProviderIconType =
  | ExternalTrackingLinkProviderEnum.ATTFleetManagement
  | ExternalTrackingLinkProviderEnum.Samsara
  | ExternalTrackingLinkProviderEnum.TruckerTools
  | ExternalTrackingLinkProviderEnum.Geotab

type ProviderIconComponent = React.FC<{ size?: number }>

const providerIcons: Record<ProviderIconType, ProviderIconComponent> = {
  [ExternalTrackingLinkProviderEnum.ATTFleetManagement]: ATTFleetManagementIcon,
  [ExternalTrackingLinkProviderEnum.Samsara]: SamsaraIcon,
  [ExternalTrackingLinkProviderEnum.TruckerTools]: TruckerToolsIcon,
  [ExternalTrackingLinkProviderEnum.Geotab]: GeotabIcon
} as const

/**
 * Renders the appropriate icon based on the tracking provider
 */
const ProviderIcon = ({ provider, size = 3 }: IProviderIcon) => {
  if (!provider || !(provider in providerIcons)) {
    return <LinkIcon size={size * 4} />
  }

  const Icon = providerIcons[provider as ProviderIconType]
  return <Icon size={size} />
}

export default ProviderIcon
